module.exports = __webpack_public_path__ + "static/media/open-menu.12327444.svg";